// Used for managing responsive conditions.
export function handleResponsive(condition, isTrue, isFalse) {
  return condition ? isTrue : isFalse;
}
